// ─── Indian Location Data ──────────────────────────────────────────────────
// Comprehensive Tamil Nadu districts, cities, and localities.
// Used by LocationAutocomplete for real-time suggestions.
//
// Structure: each entry is a "city" (which can also be a major town/taluk)
// with a full list of its localities/sub-areas.

export const LOCATION_DATA = [

  // ══════════════════════════════════════════════════════════════════════════
  // KANYAKUMARI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Nagercoil",
    state: "Tamil Nadu",
    localities: [
      "Vadasery", "Therakalputhoor", "Parvathipuram", "Ramanputhoor",
      "Vetturnimadam", "Peruvilai", "Keezhavannanvilai", "Kottar",
      "Krishnankoil", "Vellimadam", "Mondaikadu", "Azhagappapuram",
      "Ponmanai", "Thiruvananthapuram Road", "Marthandam", "Colachel",
      "Kottaram", "Edalakudi", "Palliyadi", "Mekkamandapam",
      "Neyyoor", "Nithiravilai", "Karungal", "Thuckalay",
      "Kaliakkavilai", "Thiruvattar", "Suchindram", "Kaniyakulam",
      "Ozhuginasery", "Kanyakumari Road", "Pillaithoppu", "Bethlahem",
      "Bishop Road", "Rajakkamangalam", "Edalakudi", "Bhoothapandy",
      "Mulagumoodu", "Aramboly", "Arumanai", "Chitharal",
      "Melpuram", "Irenipuram", "Kadukarai", "Kattuputhur",
      "Peyankuzhi", "Thalankottai", "Kurunthancode", "Vallankumaranvilai",
      "Erachakulam", "Thengampudur"
    ],
  },
  {
    city: "Kanniyakumari",
    state: "Tamil Nadu",
    localities: [
      "Kanniyakumari", "Kavalkinaru", "Agastheeswaram", "Thovalai",
      "Kalkulam", "Killiyoor", "Vilavancode", "Padmanabhapuram",
      "Kuzhithurai", "Eraviputhoor", "Ethamozhy", "Mondaikadu",
      "Aazhiamparai", "Manavalakurichi", "Kottaram", "Edayoor",
      "Puthalam", "Ganapathipuram", "Thoothoor", "Enayam"
    ],
  },
  {       
    city: "Marthandam",
    state: "Tamil Nadu",
    localities: [
      "Marthandam", "Karungal", "Parassala Road", "Vellamadam",
      "Mulagumoodu", "Thiruvattar", "Mancode", "Kattathurai",
      "Anjugramam", "Arumanai", "Kaliyakkavilai", "Puthalam"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // VIRUDHUNAGAR DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Srivilliputhur",
    state: "Tamil Nadu",
    localities: [
      "Roja Nagar", "Alagar Garden", "Ashok Nagar", "Mullai Nagar",
      "Sri Balaji Nagar", "Shri Krish Garden", "Gandhi Nagar",
      "Nehru Nagar", "Anna Nagar", "Periyar Nagar", "Ambedkar Nagar",
      "Kamarajar Nagar", "Bharathi Nagar", "Rajaji Nagar",
      "Mosque Street", "North Car Street", "South Car Street",
      "East Car Street", "West Car Street", "Bypass Road",
      "Sivakasi Road", "Rajapalayam Road", "Main Bazaar",
      "Srivilliputhur Town", "Pillaiyarkovil Street", "Masjid Street",
      "Railway Station Road", "Watrap Road", "Sankarankovil Road",
      "Aruppukottai Road", "Kariapatti", "Vembakottai", "Tiruchuli"
    ],
  },
  {
    city: "Virudhunagar",
    state: "Tamil Nadu",
    localities: [
      "Srivilliputhur", "Sivakasi", "Rajapalayam", "Sattur",
      "Watrap", "Aruppukottai", "Kariapatti", "Vembakottai", "Tiruchuli",
      "Virudhunagar Town", "Sivakasi Road", "Gandhi Nagar",
      "Anna Nagar", "Periyar Nagar", "Raja Colony",
      "Murugan Nagar", "Lakshmi Nagar", "Lalitha Nagar",
      "Railway Station Area", "New Bus Stand Area", "Market Road"
    ],
  },
  {
    city: "Sivakasi",
    state: "Tamil Nadu",
    localities: [
      "Sivakasi Town", "Vembakottai", "Thiruthangal", "Seithur",
      "East Street", "West Street", "North Street", "South Street",
      "Ayyanar Kovil Street", "Madurai Road", "Kovilpatti Road",
      "Anna Nagar", "Gandhi Nagar", "Bharathi Nagar",
      "Raja Nagar", "Lakshmi Nagar", "New Colony", "Old Colony",
      "Puliankudi", "Surandai", "Kallidaikurichi"
    ],
  },
  {
    city: "Rajapalayam",
    state: "Tamil Nadu",
    localities: [
      "Rajapalayam Town", "Kariapatti Road", "Sankarankovil Road",
      "North Street", "South Street", "East Street", "West Street",
      "Gandhi Nagar", "Subbiah Colony", "Rajaji Street",
      "Market Road", "Hospital Road", "Station Road",
      "Tenkasi Road", "Virudhunagar Road", "Muthiah Colony",
      "Sundarapandiam Colony", "Collector Office Road"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // THOOTHUKUDI (TUTICORIN) DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Thoothukudi",
    state: "Tamil Nadu",
    localities: [
      "Harbour", "Millerpuram", "VOC Nagar", "Palayamkottai Road",
      "Srivaikuntam", "Tiruchendur", "Kovilpatti", "Kayalpatnam",
      "Vilathikulam", "Sattankulam", "Udangudi", "Ettayapuram",
      "Ottapidaram", "Nazareth", "Arockiapuram", "Bryant Nagar",
      "Sipcot", "Muthaiyapuram", "Caldwell Colony",
      "Punnakayal", "Alwarthirunagari", "Thisayanvilai",
      "New Colony", "Rachel Nagar", "Tuticorin Main Road"
    ],
  },
  {
    city: "Srivaikuntam",
    state: "Tamil Nadu",
    localities: [
      "Srivaikuntam Town", "Alwarthirunagari", "Meignanapuram",
      "Krishnaperi", "Srivaikuntam Bypass", "Temple Street",
      "East Mada Street", "West Mada Street", "Market Street",
      "Therespuram", "Kulasekarapattinam", "Kombuthurai"
    ],
  },
  {
    city: "Kovilpatti",
    state: "Tamil Nadu",
    localities: [
      "Kovilpatti Town", "Thoothukudi Road", "Sivakasi Road",
      "North Street", "South Street", "Anna Nagar",
      "Gandhi Nagar", "Bharathi Nagar", "Pillayarpuram",
      "Mela Street", "Kila Street", "Raja Street",
      "Ettayapuram Road", "Railway Station Road"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // TIRUNELVELI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Tirunelveli",
    state: "Tamil Nadu",
    localities: [
      "Tirunelveli Junction", "Tirunelveli Town", "Palayamkottai",
      "Melapalayam", "Pettai", "Vannarpettai", "NGO Colony",
      "Kamarajar Nagar", "Nanguneri", "Cheranmahadevi",
      "Ambasamudram", "Radhapuram", "Manur", "Valliyur",
      "Tisayanvilai", "Kalakadu", "Panagudi",
      "Gangaikondan", "Kurukalpatti", "Thachanallur",
      "Perumalpuram", "Krishnapuram", "Mela Street",
      "SN High Road", "Bibi Kulam", "Abraham Pandithar Road",
      "Arunachalapuram", "Bethlehem Colony", "Balasubramaniapuram",
      "Pettai", "Vikramasingapuram", "Servaikarpatti"
    ],
  },
  {
    city: "Tenkasi",
    state: "Tamil Nadu",
    localities: [
      "Tenkasi Town", "Sankarankovil", "Sivagiri", "Alangulam",
      "Kadayanallur", "Shenkottai", "V.K.Pudur", "Thiruvengadam",
      "Puliyangudi", "Vasudevanallur", "Courtallam",
      "Surandai", "Kallidaikurichi", "Pavoorchatram",
      "Pappakudi", "Melagaram", "Keelathooval"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // CHENNAI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Chennai",
    state: "Tamil Nadu",
    localities: [
      "Adyar", "Anna Nagar", "T. Nagar", "Velachery", "Porur", "Tambaram",
      "Sholinganallur", "Perungudi", "OMR", "ECR", "Mylapore", "Nungambakkam",
      "Egmore", "Kilpauk", "Vadapalani", "Kodambakkam", "Valasaravakkam",
      "Ambattur", "Avadi", "Kolathur", "Perambur", "Choolaimedu", "Saidapet",
      "Guindy", "Chromepet", "Pallavaram", "Madipakkam", "Medavakkam",
      "Thoraipakkam", "Perungalathur", "Poonamallee", "Thirumangalam",
      "Koyambedu", "Arumbakkam", "Mogappair", "Thiruvottiyur", "Tondiarpet",
      "Purasawalkam", "Chetpet", "Alwarpet", "Besant Nagar", "Palavakkam",
      "Karapakkam", "Navalur", "Siruseri", "Kelambakkam", "Perumbakkam",
      "Virugambakkam", "Ashok Nagar", "KK Nagar", "Nanganallur",
      "Pammal", "Selaiyur", "Sembakkam", "Chitlapakkam",
      "Teynampet", "Royapettah", "Triplicane", "Chepauk",
      "Sowcarpet", "Park Town", "Mint", "George Town",
      "Washermenpet", "Otteri", "Villivakkam", "Ayanavaram",
      "Korattur", "Padi", "Senneerkuppam", "Nerkundram"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // COIMBATORE DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Coimbatore",
    state: "Tamil Nadu",
    localities: [
      "RS Puram", "Peelamedu", "Singanallur", "Gandhipuram", "Saibaba Colony",
      "Ramanathapuram", "Ondipudur", "Vadavalli", "Saravanampatty", "Kalapatti",
      "Thudiyalur", "Kuniyamuthur", "Hopes", "Kovaipudur", "Uppilipalayam",
      "Kavundampalayam", "Podanur", "Annur", "Sulur", "Kinathukadavu",
      "Mettupalayam", "Karamadai", "Perur", "Vellalore",
      "Goldwins", "Tidel Park", "Brookefields", "Race Course",
      "Town Hall", "Ramnagar", "Sidhapudur", "Pappanaickenpalayam",
      "Sowripalayam", "Eachanari", "Chettipalayam", "Narasimhanaickenpalayam",
      "Thondamuthur", "Madukkarai", "Saravanampatti", "Vilankurichi"
    ],
  },
  {
    city: "Pollachi",
    state: "Tamil Nadu",
    localities: [
      "Pollachi Town", "Anaimalai", "Valparai", "Udumalaipettai",
      "Palladam", "Dharapuram", "Kangeyam", "Pongalur",
      "Kinathukadavu", "Zamin Uthukuli", "Somanur", "Periyanaickenpalayam"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // MADURAI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Madurai",
    state: "Tamil Nadu",
    localities: [
      "Anna Nagar", "KK Nagar", "Thiruparankundram", "Palanganatham",
      "Villapuram", "Simmakkal", "Tallakulam", "Goripalayam",
      "Iyer Bungalow", "Arasaradi", "Alagar Kovil Road", "TVS Nagar",
      "Koodal Nagar", "Nagamalai Pudukottai", "Umachikulam",
      "Vilankurichi", "Melur", "Sholavandan", "Usilampatti",
      "Vadipatti", "Tirumangalam", "Thirumohur", "Avaniapuram",
      "Kappalur", "Kochadai", "Sakkimangalam", "Arappalayam",
      "Teppakulam", "Vandiyur", "Sellur", "Bibi Kulam",
      "Anaiyur", "Subramaniyapuram", "Visalakshi Nagar",
      "Narimedu", "Sivagangai Road", "Tirupparankundram",
      "Othakadai", "Pandalkudi", "Solaiyanallur", "Madurai East",
      "Madurai North", "Madurai South", "Alagarkoil"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // TIRUCHIRAPPALLI (TRICHY) DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Tiruchirappalli",
    state: "Tamil Nadu",
    localities: [
      "Srirangam", "KK Nagar", "Thillai Nagar", "Ariyamangalam",
      "Ponmalai", "Manachanallur", "Woraiyur", "Palpannai",
      "Kattur", "Cantonment", "Manapparai", "Musiri", "Lalgudi",
      "Pullambadi", "Golden Rock", "Puthur", "Thiruverumbur",
      "Tiruverumbur", "Karumandapam", "Vayalur", "Sathyamangalam",
      "Bikshandarkoil", "Mannarpuram", "Rathna Nagar",
      "VOC Nagar", "Engineers Colony", "Navalpattu",
      "Periyamadurai", "Tennur", "Thathanur", "Thuvakudi",
      "Samayapuram", "Kondayampettai", "Rangasamudram"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // SALEM DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Salem",
    state: "Tamil Nadu",
    localities: [
      "Hasthampatti", "Fairlands", "Suramangalam", "Shevapet",
      "Ammapet", "Alagapuram", "Swarnapuri", "Yercaud Road",
      "Attur", "Mettur", "Omalur", "Kondalampatti", "Gangavalli",
      "Sankagiri", "Edappadi", "Vazhapadi", "Karuppur",
      "Five Roads", "Gugai", "Meyyanur", "Fort Junction",
      "Kitchipalayam", "Periyapattinam", "Kondalampatti",
      "Narasothipatty", "Ramakrishnapuram", "Salem Junction"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // TIRUPPUR DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Tiruppur",
    state: "Tamil Nadu",
    localities: [
      "Kumaran Road", "Old Bus Stand", "Nallur", "Muthur",
      "Avinashi", "Dharapuram", "Kangeyam", "Palladam",
      "Mangalam", "Rayapuram", "Kasipalayam", "Velampalayam",
      "Udumalaipettai", "Madathukulam", "Thirumuruganpoondi",
      "KTC Nagar", "Market Road", "Nehru Nagar",
      "New Tirupur Area", "Periyasemur", "Anupparpalayam",
      "Selvapuram", "Anugraha Nagar", "Subramaniapuram",
      "Sathy Road", "Coimbatore Road", "Erode Road"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // ERODE DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Erode",
    state: "Tamil Nadu",
    localities: [
      "Perundurai", "Bhavani", "Gobichettipalayam", "Sathyamangalam",
      "Bargur", "Anthiyur", "Kodumudi", "Uthukuli", "Vellakoil",
      "Sivagiri", "Modakkurichi", "Chithode", "Veerappanchatram",
      "Mettur Road", "Laxmipuram", "Checker", "Old Bus Stand",
      "Collectorate", "Karungalpalayam", "Surampatti",
      "Nerinjipettai", "Thindal", "Kandhampatti", "Kavindapadi"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // VELLORE DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Vellore",
    state: "Tamil Nadu",
    localities: [
      "Katpadi", "Ariyur", "Bagayam", "Gandhi Nagar", "Sathuvachari",
      "CMC Hospital Area", "Arcot", "Ranipet", "Ambur", "Vaniyambadi",
      "Gudiyattam", "Walajah", "Anaicut", "Kaniyambadi",
      "Officers Line", "Krishnapuram", "Sripuram",
      "Fort Area", "VIT Road", "Virudhambakkam",
      "Siruthozhil Nagar", "New Colony", "Avanam",
      "Viswasapuram", "Alamelumangapuram"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // KANCHIPURAM DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Kanchipuram",
    state: "Tamil Nadu",
    localities: [
      "Singaperumalkoil", "Chengalpattu", "Uthiramerur", "Walajabad",
      "Sriperumbudur", "Tambaram", "Maduranthakam", "Maraimalai Nagar",
      "Padappai", "Kundrathur", "Guduvanchery",
      "East Mada Street", "West Mada Street", "Pillaiyar Koil Street",
      "Egmore Road", "Kamakshi Amman Kovil Area",
      "Thirumayilai", "Gandhi Nagar", "Kamatchi Colony",
      "Silkweavers Colony", "Devaneri"
    ],
  },
  {
    city: "Sriperumbudur",
    state: "Tamil Nadu",
    localities: [
      "Sriperumbudur Town", "SIPCOT", "Oragadam", "Irungattukottai",
      "Vallam", "Padappai", "Singaperumalkoil", "Kundrathur",
      "Mevalurkuppam", "Kannigaipair"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // DINDIGUL DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Dindigul",
    state: "Tamil Nadu",
    localities: [
      "Palani", "Kodaikanal", "Natham", "Oddanchatram", "Nilakottai",
      "Batlagundu", "Vedasandur", "Athoor", "Gujiliamparai",
      "Sivalaperi", "Reddiarchatram", "Shanarpatti",
      "Chinnalapatti", "Kamalapuram", "Siruvayal",
      "Valvaithankoottai", "Thadikombu", "Nehru Nagar"
    ],
  },
  {
    city: "Kodaikanal",
    state: "Tamil Nadu",
    localities: [
      "Kodaikanal Town", "Coaker's Walk", "Bryant Park Area",
      "Berijam", "Pallangi", "Perumalmalai", "Poombarai",
      "Mannavanur", "Kukkal", "Observatory Road",
      "Kodai Road", "Munjikal", "Pillar Rocks Road"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // THANJAVUR DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Thanjavur",
    state: "Tamil Nadu",
    localities: [
      "Kumbakonam", "Papanasam", "Thiruvaiyaru", "Pattukkottai",
      "Budalur", "Orathanadu", "Pattamangalam", "Needamangalam",
      "Peravurani", "Thiruvidaimarudur", "Patteeswaram",
      "Hospital Road", "Medical College Road", "Bus Stand Area",
      "Rajaji Road", "Anna Salai", "Mullai Nagar",
      "Gandhiji Road", "Trichy Road", "Serfoji Colony"
    ],
  },
  {
    city: "Kumbakonam",
    state: "Tamil Nadu",
    localities: [
      "Kumbakonam Town", "Swamimalai", "Darasuram", "Papanasam Road",
      "Mayiladuthurai Road", "Tanjore Road", "Navaratna Agraharam",
      "Big Street", "TSR Big Street", "Head Post Office Area",
      "Sakkottai", "Saliyamangalam", "Melaiyur", "Kalluthankadu",
      "Ammapettai", "Govindapuram"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // TIRUVALLUR DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Tiruvallur",
    state: "Tamil Nadu",
    localities: [
      "Ambattur", "Avadi", "Thiruvallur Town", "Poonamallee",
      "Redhills", "Minjur", "Gummidipoondi", "Uthukottai",
      "Thiruvallur Junction", "Tiruttani", "Pallipat", "Ponneri",
      "Kollapancheri", "Elavur", "Perambakkam", "Villivakkam"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // TIRUVANNAMALAI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Tiruvannamalai",
    state: "Tamil Nadu",
    localities: [
      "Tiruvannamalai Town", "Cheyyar", "Vembakkam", "Polur",
      "Chetpet", "Arni", "Vandavasi", "Chengam", "Kilpennathur",
      "Kalasapakkam", "Arani", "Thandarampattu",
      "Big Kanchipuram Road", "Bye Pass Road",
      "Girivalam Road", "Arunachaleswarar Temple Area",
      "Sri Ramana Nagar", "Ashramam"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // CUDDALORE DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Cuddalore",
    state: "Tamil Nadu",
    localities: [
      "Chidambaram", "Kattumannargudy", "Panruti", "Virudhachalam",
      "Neyveli", "Bhuvanagiri", "Srimushnam", "Kurinjipadi",
      "Tittakudi", "Vriddhachalam", "Mangalur",
      "Sidarth Nagar", "New Colony", "South Colony",
      "North Colony", "SIPCOT", "Thittakudi"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // NAGAPATTINAM DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Nagapattinam",
    state: "Tamil Nadu",
    localities: [
      "Vedaranyam", "Sirkazhi", "Mayiladuthurai", "Poompuhar",
      "Kilvelur", "Thalainayar", "Thiruvarur", "Nagore",
      "Karaikal", "Kollidam", "Keelvelur",
      "Komal", "Sembanarkoil", "Papanasam"
    ],
  },
  {
    city: "Mayiladuthurai",
    state: "Tamil Nadu",
    localities: [
      "Mayiladuthurai Town", "Sirkazhi", "Kuthalam", "Tharangambadi",
      "Poompuhar", "Sembanarkoil", "Papanasam Road",
      "Manalmedu", "Thirukadaiyur", "Keelvelur"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // PUDUKKOTTAI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Pudukkottai",
    state: "Tamil Nadu",
    localities: [
      "Karaikudi", "Aranthangi", "Alangudi", "Illuppur",
      "Viralimalai", "Tirumayam", "Gandarvakkottai", "Ponnamaravathi",
      "Avudaiyarkoil", "Kulathur", "Mimisal",
      "Mathur", "Silattur", "Thirumayam Road"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // RAMANATHAPURAM DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Ramanathapuram",
    state: "Tamil Nadu",
    localities: [
      "Rameswaram", "Mandapam", "Paramakudi", "Kadaladi",
      "Mudukulathur", "Kamuthi", "Keelakarai", "Tiruvadanai",
      "Pamban", "Devipattinam", "Ramanathapuram Town",
      "Bogalur", "Ervadi", "Emaneswaram"
    ],
  },
  {
    city: "Rameswaram",
    state: "Tamil Nadu",
    localities: [
      "Rameswaram Town", "Pamban", "Mandapam", "Agni Theertham",
      "Dhanushkodi Road", "Ramanathaswamy Temple Area",
      "East Car Street", "West Car Street", "North Car Street",
      "South Car Street", "Sannidhi Street"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // SIVAGANGAI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Sivagangai",
    state: "Tamil Nadu",
    localities: [
      "Karaikudi", "Devakottai", "Thiruppuvanam", "Ilayankudi",
      "Tiruppattur", "Manamadurai", "Singampuneri", "Kalayarkoil",
      "Kalaiyarkoil", "Sakkottai", "Kannangudi",
      "Sivagangai Town", "Pillayarpatti", "Nattarasankottai"
    ],
  },
  {
    city: "Karaikudi",
    state: "Tamil Nadu",
    localities: [
      "Karaikudi Town", "Devakottai Road", "Madurai Road",
      "Kanadukathan", "Kottaiyur", "Pillaiyarpatti",
      "Sembanur", "Rajagiri", "Chettinad",
      "West Street", "East Street", "North Street", "South Street",
      "Anna Nagar", "Gandhi Nagar"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // KARUR DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Karur",
    state: "Tamil Nadu",
    localities: [
      "Kulithalai", "Krishnarayapuram", "Aravakurichi", "Manmangalam",
      "Thanthoni", "Pallapatti", "Punjai Puliampatti", "Kadavur",
      "Karur Town", "Erode Road", "Trichy Road",
      "Mettur Road", "Gandhi Nagar", "Anna Nagar",
      "Railway Station Area", "Collectorate Area"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // NILGIRIS DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Ooty",
    state: "Tamil Nadu",
    localities: [
      "Ooty Town", "Coonoor", "Kotagiri", "Gudalur", "Kundah",
      "Lovedale", "Wellington", "Udhagamandalam", "Pandalur",
      "Nanjanad", "Kothagiri Road", "Emerald",
      "Pykara", "Mukurthi", "Doddabetta Road",
      "Race Course", "Charring Cross", "Wax World Road"
    ],
  },
  {
    city: "Coonoor",
    state: "Tamil Nadu",
    localities: [
      "Coonoor Town", "Upper Coonoor", "Sim's Park Area",
      "Runnymede", "Thiashola", "Halycone",
      "Dolphin's Nose Road", "Lamb's Rock Road",
      "Bedford", "Kodanadu", "Mettupalayam Road"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // THENI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Theni",
    state: "Tamil Nadu",
    localities: [
      "Periyakulam", "Uthamapalayam", "Cumbum", "Gudalur",
      "Bodinayakanur", "Andipatti", "Chinnamanur", "Theni Town",
      "Munnar Road", "Madurai Road", "Bodi",
      "Kambam", "Gudalur", "Thamaraikulam"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // NAMAKKAL DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Namakkal",
    state: "Tamil Nadu",
    localities: [
      "Rasipuram", "Tiruchengodu", "Kumarapalayam", "Kolli Hills",
      "Senthamangalam", "Paramathi Velur", "Mohanur", "Namakkal Town",
      "Erode Road", "Salem Road", "Trichy Road",
      "Gandhi Market", "Anna Salai", "Kongu Nagar"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // KRISHNAGIRI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Krishnagiri",
    state: "Tamil Nadu",
    localities: [
      "Hosur", "Denkanikottai", "Uthangarai", "Kaveripattinam",
      "Bargur", "Shoolagiri", "Veppanapalli", "Krishnagiri Town",
      "Pochampalli", "Kelamangalam", "Mathur", "Thally",
      "Hosur Road", "Bangalore Road", "Salem Road"
    ],
  },
  {
    city: "Hosur",
    state: "Tamil Nadu",
    localities: [
      "Hosur Town", "SIPCOT", "Mathigiri", "Kelamangalam Road",
      "Krishnagiri Road", "Bangalore Road", "Thally Road",
      "Shoolagiri", "Rayakottai", "Nagondahalli",
      "Vengikkal", "Karapalli", "Begur"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // DHARMAPURI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Dharmapuri",
    state: "Tamil Nadu",
    localities: [
      "Harur", "Pennagaram", "Palacode", "Karimangalam",
      "Nallampalli", "Morappur", "Pappireddipatti", "Dharmapuri Town",
      "Salem Road", "Hogenakkal Road", "Kapilamalai",
      "Marandahalli", "Palacode", "Agaram"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // ARIYALUR DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Ariyalur",
    state: "Tamil Nadu",
    localities: [
      "Jayamkondam", "Andimadam", "Sendurai", "Udayarpalayam",
      "T. Palur", "Ariyalur Town", "Trichy Road",
      "Perambalur Road", "Cement Factory Area",
      "Muthukulathur", "Andimadam Road"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // PERAMBALUR DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Perambalur",
    state: "Tamil Nadu",
    localities: [
      "Kunnam", "Alathur", "Veppur", "Eraiyur", "Perambalur Town",
      "Trichy Road", "Salem Road", "Ariyalur Road",
      "Poolambadi", "Veppanthattai", "Thirumanur"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // TIRUVARUR DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Tiruvarur",
    state: "Tamil Nadu",
    localities: [
      "Mannargudi", "Nannilam", "Kodavasal", "Papanasam",
      "Thiruthuraipoondi", "Valangaiman", "Tiruvarur Town",
      "Needamangalam", "Muthupettai", "Thanjavur Road"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // CHENGALPATTU DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Chengalpattu",
    state: "Tamil Nadu",
    localities: [
      "Chengalpattu Town", "Tambaram", "Pallavaram", "Vandalur",
      "Guduvanchery", "Maraimalai Nagar", "Maduranthakam",
      "Cheyyur", "Thiruporur", "Urapakkam", "Perungalathur",
      "Singaperumalkoil", "Paranur", "Karanodai"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // RANIPET DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Ranipet",
    state: "Tamil Nadu",
    localities: [
      "Ranipet Town", "Walajah", "Arakkonam", "Arcot", "Nemili",
      "Sholinghur", "Timiri", "Perambakkam", "Vinnamangalam",
      "Chennai Bypass Road", "Vellore Road"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // TIRUPATHUR DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Tirupathur",
    state: "Tamil Nadu",
    localities: [
      "Tirupathur Town", "Vaniyambadi", "Ambur", "Natrampalli",
      "Jolarpet", "Kandili", "Alangayam", "Madhanur",
      "Vellore Road", "Chennai Road"
    ],
  },
  {
    city: "Vaniyambadi",
    state: "Tamil Nadu",
    localities: [
      "Vaniyambadi Town", "Ambur Road", "Tirupathur Road",
      "Latteri", "Pernambut", "Bargur Road",
      "Old Bus Stand", "New Bus Stand"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // KALLAKURICHI DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Kallakurichi",
    state: "Tamil Nadu",
    localities: [
      "Kallakurichi Town", "Sankarapuram", "Chinnasalem",
      "Tirukkoyilur", "Ulundurpet", "Rishivandiyam",
      "Mangalapuram", "Vanapuram"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // VILLUPURAM DISTRICT
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Villupuram",
    state: "Tamil Nadu",
    localities: [
      "Villupuram Town", "Vikravandi", "Tindivanam", "Gingee",
      "Vanur", "Marakkanam", "Melmalayanur", "Sankarapuram",
      "Pondicherry Road", "Cuddalore Road", "Chennai Road",
      "Ulundurpet", "Tirukkoyilur", "Chettipattu"
    ],
  },

  // ══════════════════════════════════════════════════════════════════════════
  // OTHER MAJOR INDIAN CITIES
  // ══════════════════════════════════════════════════════════════════════════
  {
    city: "Mumbai",
    state: "Maharashtra",
    localities: [
      "Andheri", "Bandra", "Borivali", "Dadar", "Malad", "Powai",
      "Thane", "Navi Mumbai", "Juhu", "Worli", "Lower Parel",
      "Mulund", "Ghatkopar", "Kurla", "Goregaon", "Kandivali",
      "Vile Parle", "Santacruz", "Colaba", "Fort", "Chembur",
      "Mira Road", "Vasai", "Virar", "Dombivli", "Kalyan"
    ],
  },
  {
    city: "Pune",
    state: "Maharashtra",
    localities: [
      "Hinjewadi", "Wakad", "Baner", "Kothrud", "Koregaon Park",
      "Hadapsar", "Pimpri", "Chinchwad", "Aundh", "Viman Nagar",
      "Kharadi", "Magarpatta", "Shivajinagar", "Camp", "Deccan",
      "Katraj", "Kondhwa", "Undri", "Wagholi", "Pisoli",
      "Bavdhan", "Sus", "Pashan", "Balewadi", "Punawale"
    ],
  },
  {
    city: "Bangalore",
    state: "Karnataka",
    localities: [
      "Whitefield", "Electronic City", "Marathahalli", "Sarjapur Road",
      "Indiranagar", "Koramangala", "JP Nagar", "Jayanagar",
      "HSR Layout", "Bellandur", "Yelahanka", "Hebbal",
      "Malleshwaram", "Rajajinagar", "Bannerghatta Road",
      "Kanakapura Road", "Devanahalli", "Hennur",
      "Kalyan Nagar", "RT Nagar", "Banaswadi", "Domlur",
      "Bommanahalli", "BTM Layout", "Wilson Garden"
    ],
  },
  {
    city: "Hyderabad",
    state: "Telangana",
    localities: [
      "Gachibowli", "HITEC City", "Madhapur", "Kondapur",
      "Banjara Hills", "Jubilee Hills", "Kukatpally", "Secunderabad",
      "Begumpet", "Ameerpet", "LB Nagar", "Attapur",
      "Mehdipatnam", "Uppal", "Miyapur", "Nallagandla",
      "Manikonda", "Tellapur", "Kokapet", "Narsingi"
    ],
  },
  {
    city: "Delhi",
    state: "Delhi",
    localities: [
      "Dwarka", "Rohini", "Janakpuri", "Vasant Kunj", "Saket",
      "Greater Kailash", "Defence Colony", "Lajpat Nagar",
      "Karol Bagh", "Connaught Place", "Pitampura",
      "Paschim Vihar", "Uttam Nagar", "Shahdara",
      "Preet Vihar", "Noida Extension", "Gurugram",
      "Faridabad", "Ghaziabad", "Noida"
    ],
  },
  {
    city: "Kolkata",
    state: "West Bengal",
    localities: [
      "Salt Lake", "Rajarhat", "New Town", "Park Street",
      "Ballygunge", "Alipore", "Behala", "Tollygunge",
      "Dum Dum", "Howrah", "Jadavpur", "Kasba",
      "Gariahat", "Lake Town", "Ultadanga"
    ],
  },
];

// ─── Suggestion Builder ──────────────────────────────────────────────────────
/**
 * Returns a list of location suggestions for the given query.
 * @param {string} query       - User's search input
 * @param {'all'|'city'|'locality'} mode
 * @param {string|null} cityFilter - If set (locality mode), only show localities from this city
 * @param {number} maxResults  - Maximum results to return (default 50)
 * @returns {Array} suggestions
 */
export function getLocationSuggestions(query, mode = "all", cityFilter = null, maxResults = 50) {
  const q = query.toLowerCase().trim();
  if (!q || q.length < 1) return [];

  const cityResults = [];
  const localityResults = [];

  for (const { city, state, localities } of LOCATION_DATA) {
    const cityLower = city.toLowerCase();
    const cityMatches = cityLower.includes(q);

    // ── City suggestions ──────────────────────────────────────────────────
    if ((mode === "all" || mode === "city") && cityMatches && !cityFilter) {
      cityResults.push({
        label: city,
        display: city,
        subtitle: state,
        type: "city",
        city,
        state,
      });
    }

    // ── Locality suggestions ──────────────────────────────────────────────
    if (mode !== "city") {
      // When cityFilter is active, skip non-matching cities
      if (cityFilter && cityLower !== cityFilter.toLowerCase()) continue;

      for (const locality of localities) {
        const localityLower = locality.toLowerCase();
        const localityMatches = localityLower.includes(q);

        // Include locality if: its name matches, OR parent city matches (in 'all' mode)
        if (localityMatches || (cityMatches && mode === "all")) {
          localityResults.push({
            label: `${locality}, ${city}`,
            display: cityFilter ? locality : `${locality}, ${city}`,
            subtitle: cityFilter ? city : state,
            type: "locality",
            city,
            locality,
            state,
            _localityMatch: localityMatches,
            _cityMatch: cityMatches,
          });
        }
      }
    }
  }

  // Sort: direct locality name matches first, then city-match localities
  localityResults.sort((a, b) => {
    if (a._localityMatch && !b._localityMatch) return -1;
    if (!a._localityMatch && b._localityMatch) return 1;
    // Within same match type, prefer shorter labels (more specific)
    return a.label.length - b.label.length;
  });

  const combined = [
    ...cityResults.slice(0, 6),
    ...localityResults,
  ];

  return combined.slice(0, maxResults);
}
